export default {"src":"/_next/static/media/tab-bell-active.bf629dce.svg","height":40,"width":41};